module.exports = __webpack_public_path__ + "img/2-4.2b5e50da.svg";